import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "isEnableTranslate" : false,
    "isEnableArchived":true,
}

const webLocalStorageSettingData = createSlice({
    name:'webLocalStorageSettingData',
    initialState,
    reducers:{
        webLocalStorageSetting: (_state,payload)=>{
            const {payload:{ translate = false, isEnableArchived = true } = { } } = payload;
            return {
                ..._state,
                "id" : uuidv4(),
                "isEnableTranslate":translate,
                "isEnableArchived":isEnableArchived
            }
        }
    }
});

export default webLocalStorageSettingData.reducer
export const webLocalStorageSetting = webLocalStorageSettingData.actions.webLocalStorageSetting